import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/adquisiciones/notas-entrada', documento: 'adquisiciones', acceso: 'sesion', filas: ['049'],
  cita: 'Areas/Adquisiciones/Controllers/NotasEntradaController.cs',
} satisfies RutaProd;
